import { decrypt, encrypt } from '@/common/securityUtils';
import { Spinner } from '@/components/Spinner';
import { useDynamicLocale } from '@/hoslog-intl';
import { useCustomerWithdrawalDetail } from './hooks/useCustomerWithdrawalQuery';
import { ManageCustomerWithdrawal } from './ManageCustomerWithdrawal';

export const ManageCustomerWithdrawalContainer = ({
  activeTab,
  withdrawalId,
}: {
  activeTab: string;
  withdrawalId?: string;
}) => {
  const { withdrawalDetail, isLoading } = useCustomerWithdrawalDetail(withdrawalId);
  const { t } = useDynamicLocale();
  if (isLoading) return <Spinner />;

  const userType =
    withdrawalDetail?.userType && decrypt(withdrawalDetail.userType) === '3'
      ? t('common.form.label.customer')
      : encrypt(activeTab);
  return (
    <ManageCustomerWithdrawal
      defaultValues={{
        userType,
        minAmount: String(withdrawalDetail?.minAmount?.toFixed(2) ?? '0'),
        maxAmount: String(withdrawalDetail?.maxAmount?.toFixed(2) ?? '0'),
      }}
      withdrawalId={withdrawalDetail?.withdrawalId}
    />
  );
};
